// System Features Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Fetch System Menu from backend ***** //
export const fetchSystemMenu = async ({ commit }) => {
  try {
    const result = await Axios.get(`show_sidebar_setting`)
    const data = result.data.data
    commit('setSystemMenu', data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Update System Menu ***** //
export const updateSystemMenu = async (ignored, payload = null) => {
  try {
    await Axios.post(`set_sidebar_setting`, payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}
